import { AppRole } from '../types';

const ROLE_PRECEDENCE: readonly AppRole[] = [
  'SuperAdmin',
  'Content-Manager',
  'Data-Analyst',
];

const normalizeGroup = (group: string): AppRole | null => {
  if (group === 'Admin') {
    return 'SuperAdmin';
  }

  return ROLE_PRECEDENCE.includes(group as AppRole)
    ? (group as AppRole)
    : null;
};

export const resolveAdminRole = (
  groups: readonly string[] | undefined
): AppRole | null => {
  const normalized = new Set((groups ?? []).map(normalizeGroup));
  return ROLE_PRECEDENCE.find((role) => normalized.has(role)) ?? null;
};
